module.exports = __webpack_public_path__ + "static/media/photoshop.3d25a73b.svg";